import { createCtx } from './create-context.helper';
import { ProjectSettings } from '@lib/api-interface';

export const [useProjectBranchSettingsContext, ProjectBranchSettingsContextProvider] = createCtx<ProjectSettings>();
